import { jsx } from "react/jsx-runtime";
import dedent from "dedent";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconListSvg } from "./IconListSvg.mjs";
const IconList = (props) => {
  if (process.env.NODE_ENV !== "production") {
    console.warn(
      dedent`
        The \`IconList\` component is deprecated. Please use \`IconBulletList\` instead.
            %c-<IconList />
            %c+<IconBulletList />
        %c
      `,
      "color: red",
      "color: green",
      "color: inherit"
    );
  }
  return /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconListSvg, ...svgProps }) });
};
export {
  IconList
};
